
















































import {Component, Vue, Prop, Emit} from 'vue-property-decorator';
import Carousel from '@/components/Carousel.vue';
import {VList, VListTile, VListTileAction, VNavigationDrawer} from 'vuetify/lib';

@Component({
	components: {
		Carousel,
		VList,
		VListTile,
		VListTileAction,
		VNavigationDrawer,
	},
})
export default class SideMenu extends Vue {
	@Prop()
	private drawer!: boolean;

	private get drawerND() {
		return !!this.drawer;
	}

	@Emit()
	// tslint:disable-next-line:no-empty
	private backClick() {}

	private drawerChange(v: any) {
		if (!v) {
			this.backClick();
		}
	}
}
